import { call, put, takeLatest } from "redux-saga/effects";
import { httpGetTopic } from "../../../services/autoComplete";
import { getTopicStart, getTopicSuccess, getTopicFailure } from "../reducer";

export function* getTopic({ payload }) {
  const response = yield call(httpGetTopic, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getTopicSuccess(raw));
  } else {
    yield put(getTopicFailure(message || raw.error));
  }
}

export default function* onGetTopic() {
  yield takeLatest(getTopicStart.type, getTopic);
}
